<template>
  <BModal :id="id" :visible="show" scrollable size="xl" body-class="p-0 mb-3" :hide-footer="true" @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="mb-3 mt-auto ml-auto mr-auto modal-title">Choose a Batch</h5>
      <button type="button" class="modal-close" aria-label="Close" @click="$emit('hide')">
        <i class="fa fa-times-thin" style="font-size: 1.5em" />
      </button>
    </template>
    <div class="pdp-banner px-4">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-12 text-center">
              <span class="text-header-300"> This product has multiple batches, </span>
            </div>
            <div class="col-12">
              <div class="text-center">
                <span class="text-header-300"> Please make a selection below. </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 col-sm-3 col-md-4">
          <div class="row">
            <div class="col-12 text-center center-content">
              <h3>Need More Info?</h3>
              <!-- <h5>Checkout the Product display page.</h5> -->
              <BushelBtn variant="success" class="btn btn-block mt-3" @click="closeAndOpenProductDisplayPage">
                <i class="fas fa-external-link-alt" />
              </BushelBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="allBatchesAreOnHold && isTheSeller" class="alert alert-warning mb-0 text-center">
      Note all displayed batches are on deck. This really shouldn't happen. It's possible that a batch was taken off deck on a different operation
      that is not available to this order. It's also possible that your inventory is in an invalid state. Please contact support if you need
      assistance.
    </div>
    <!-- <div class="row mt-3 mx-2">
      <div class="col-md-4 offset-md-1 text-left">
        <strong> Batches </strong><br>
      </div>
      <div class="col-md-6">
        <BushelCard
          body-class="p-0 overflow-hidden"
        >
          <div
            class="row text-center p-2"
            style="backgroundColor: rgba(55,63,67,.16);"
          >
            <div class="col">
            </div>
            <div class="col">
              <div class="col-lg-5 pt-lg-3">
                <BushelBtn
                  variant="success"
                  class="btn btn-block"
                  :disabled="((ptoTotal > batch.quantity) && !batch.disable_inventory_tracking) || !noDecimals || (batch.disable_inventory_tracking && ptoTotal <= 1)"
                  @click="createItems"
                >
                  <i class="fas fa-plus" />
                </BushelBtn>
              </div>
            </div>
          </div>
        </BushelCard>
      </div>

    </div> -->
    <div class="table-responsive">
      <table class="table table-valign-middle">
        <thead>
          <tr>
            <th class="text-center">Location</th>
            <th class="text-center">Batch Name</th>
            <th class="text-center">Batch Price</th>
            <th class="text-center">Quantity</th>
            <th class="text-center">Potency</th>
            <th v-if="showAgingField(product.category_name, 'harvest_date')" class="text-center text-nowrap">Harvest Date</th>
            <th v-if="showAgingField(product.category_name, 'extraction_date')" class="text-center text-nowrap">Extraction Date</th>
            <th v-if="showAgingField(product.category_name, 'production_date')" class="text-center text-nowrap">Production Date</th>
            <th v-if="showAgingField(product.category_name, 'best_by_date')" class="text-center text-nowrap">Expiration Date</th>
            <th class="text-center" />
          </tr>
        </thead>
        <tbody>
          <MultipleBatchLine
            v-for="batch in product.batches"
            :key="batch.id"
            :is-the-seller="isTheSeller"
            :product="product"
            :cart-items="cartItems"
            :batch="batch"
            :show-aging-fields="showAgingFields"
            @launch-p-t-o-modal="(val) => $emit('launchPTOModal', val)"
            @added-product="(val) => $emit('addedProduct', val)"
          />
        </tbody>
      </table>
    </div>
  </BModal>
</template>

<script>
import MultipleBatchLine from "./MultipleBatchLine.vue";

export default {
  components: { MultipleBatchLine },
  props: {
    show: { type: Boolean, required: true },
    id: { type: String, default: "multiBatchModal" },
    product: { type: Object, required: true },
    cartItems: { type: Array, required: true },
    isTheSeller: { type: Boolean, required: true },
    showAgingFields: { type: Boolean, default: false },
  },
  emits: ["hide", "launchProductDisplayPage", "launchPTOModal", "addedProduct"],
  data() {
    return {};
  },
  computed: {
    allBatchesAreOnHold() {
      return this.product.batches.every((batch) => batch.hold);
    },
  },
  watch: {
    product(newVal, oldVal) {
      if (!newVal || !newVal.id) {
        this.$emit("hide");
      }
    },
  },
  mounted() {},
  methods: {
    closeAndOpenProductDisplayPage() {
      this.$emit("launchProductDisplayPage");
      this.$emit("hide");
    },
    showAgingField(productCategory, field) {
      const agingDates = {
        harvest_date: ["flower", "pack to order", "plant material", "prepack", "seed", "preroll"],
        extraction_date: ["extract", "bulk extract", "cartridge"],
        production_date: ["tincture"],
        best_by_date: ["edibles & drink", "topicals & wellness"],
      };

      if (this.showAgingFields && productCategory && agingDates[field].includes(productCategory.toLowerCase())) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style>
.table tr td {
  vertical-align: middle;
}
</style>
